import { render, staticRenderFns } from "./IngredientDetail.vue?vue&type=template&id=8d8fd016&scoped=true"
import script from "./IngredientDetail.vue?vue&type=script&lang=js"
export * from "./IngredientDetail.vue?vue&type=script&lang=js"
import style0 from "./IngredientDetail.vue?vue&type=style&index=0&id=8d8fd016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8fd016",
  null
  
)

export default component.exports